import "./style.css";
import Header from "../../../componente/header";
import { useState, useEffect } from "react";
import Modal from "react-modal";
import api from "../../../services/api";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";

function LancViagem() {
  const { DateTime } = require("luxon");

  const dt = new Date();
  const dt11 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");
  let time =
    dt.getHours().toString().padStart(2, "0") +
    ":" +
    dt.getMinutes().toString().padStart(2, "0");
  let dtcadastro = dt11 + " " + time;

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    "01";

  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [abusca, setabusca] = useState("");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const [listaequipe, setlistaequipe] = useState([]);
  const [listaviagem, setlistaviagem] = useState([]);
  const [listafuncionario, setlistafuncionario] = useState([]);
  const [listaviagemfuncionario, setlistaviagemfuncionario] = useState([]);

  const [showform, setshowform] = useState(false);
  const [excluido, setexcluido] = useState(false);
  const [finalizado, setfinalizado] = useState(false);

  const [codviagem, setcodviagem] = useState(0);
  const [codequipe, setcodequipe] = useState(0);
  const [dtinicio, setdtinicio] = useState("");
  const [dtfim, setdtfim] = useState("");
  const [local, setlocal] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setcodviagem(cad.codviagem);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      ExcluirCad();
      setIsOpenMotivoExclusao(false);
      ListarViagem();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarViagem() {
    api
      .get("/v1/operacoes/viagem", {
        params: {
          busca: abusca,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistaviagem(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarViagem();
  }, [showform, abusca, dt1, dt2, excluido, finalizado]);

  useEffect(() => {
    function ListarViagemFuncionario() {
      api
        .get("/v1/operacoes/viagemfuncionario", {
          params: {
            busca: "",
            codviagem,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistaviagemfuncionario(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarViagemFuncionario();
  }, [showform, codviagem]);

  useEffect(() => {
    function ListarFuncionario() {
      api
        .get("v1/cadastro/funcionario", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistafuncionario(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarFuncionario();
  }, [showform]);

  function CadastrarNovo() {
    api
      .post(
        "v1/operacoes/viagem",
        {
          dtlancamento: dtcadastro,
          dtinicio,
          dtfim,
          local,
          codequipe,
          excluido: "N",
          codempresa: localStorage.getItem("tempCodEmpresa"),
          codusuario: localStorage.getItem("tempCodUsuario"),
          finalizado: "N",
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then((response) => {
        setcodviagem(response.data.codviagem);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function SalvarEdicao() {
    api
      .put(
        "v1/operacoes/viagem",
        {
          dtinicio,
          dtfim,
          local,
          codequipe,
          codviagem,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then((response) => {
        setcodviagem(response.data.codviagem);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function closeModal() {
    setshowform(false);
  }

  function Salvar() {
    if (codequipe === 0) {
      alert("Antes de salvar, informe a equipe");
    } if (codviagem === 0) {
      CadastrarNovo();

      setshowform(false);
    } else {
      SalvarEdicao();

      setshowform(false);
    }
  }

  function Novo() {
    setcodviagem(0);
    setcodequipe(0);
    setlocal("");

    setdtinicio("");
    setdtfim("");

    setshowform(true);
  }

  function Editar(props) {
    setshowform(true);

    setcodviagem(props.codviagem);
    setcodequipe(props.codequipe);
    setlocal(props.local);

    const dt1 = DateTime.fromISO(props.dtinicio)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd");
    setdtinicio(dt1);

    const dt2 = DateTime.fromISO(props.dtfim)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd");
    setdtfim(dt2);
  }

  function ExcluirCad() {
    api
      .delete("/v1/operacoes/viagem", {
        params: {
          codviagem: codviagem,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        setexcluido(false);
        alert("Excluido com Sucesso!");
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Finalizar(cad) {
    api
      .get("/v1/operacoes/finalizarviagem", {
        params: {
          codviagem: cad.codviagem,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        setfinalizado(false);
        alert("Finalizado com Sucesso!");
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  useEffect(() => {
    function ListarEquipe() {
      api
        .get("v1/cadastro/equipe", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistaequipe(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarEquipe();
  }, [showform]);

  return (
    <>
      <Header />

      <div>
        <div>
          <PopUp isOpen={isOpen} onClose={handleClose}>
            <h2>Verificação</h2>
            <p>Tem certeza que deseja excluir esse registro?</p>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleConfirma}
                >
                  Sim
                </button>
                <button className="btn btn-danger" onClick={handleClose}>
                  Não
                </button>
              </div>
            </div>
          </PopUp>
        </div>

        <div>
          <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
            <h2>Antes de Excluir</h2>
            <p>Informe qual o motivo da exclusão?</p>

            <div className="col-sm-12">
              <label htmlFor="motivo" className="form-label">
                Motivo
              </label>
              <input
                type="text"
                id="motivo"
                className="form-control"
                placeholder="Descreva aqui"
                value={edtMotivo}
                onChange={(e) => setEdtMotivo(e.target.value)}
              />
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleInformarMotivoExclusao}
                >
                  Informar
                </button>
                <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                  Cancelar
                </button>
              </div>
            </div>
          </PopUpMotivoExclusao>
        </div>

        <Modal
          isOpen={showform}
          onRequestClose={closeModal}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
        >
          <div className="container-fluid h-100">
            <div className="row">
              <h2>Novo Lançamento</h2>
            </div>
            <div className="row">
              <hr />
            </div>

            <div className="row">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="local" className="form-label">
                      Local da Viagem
                    </label>
                    <input
                      type="text"
                      id="local"
                      className="form-control"
                      value={local}
                      onChange={(e) => setlocal(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="dtinicio" className="form-label">
                      Dt. Início
                    </label>
                    <input
                      type="date"
                      id="dtinicio"
                      className="form-control"
                      value={dtinicio}
                      onChange={(e) => setdtinicio(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="dtfim" className="form-label">
                      Dt. Fim
                    </label>
                    <input
                      type="date"
                      id="dtfim"
                      className="form-control"
                      value={dtfim}
                      onChange={(e) => setdtfim(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="equipe" className="form-label">
                      Equipe
                    </label>
                    <select
                      id="equipe"
                      className="form-select"
                      value={codequipe}
                      onChange={(e) => setcodequipe(e.target.value)}
                    >
                      <option value="0">Escolha a equipe</option>
                      {listaequipe.map(function (equipe) {
                        return (
                          <option
                            key={equipe.codequipe}
                            value={equipe.codequipe}
                          >
                            {equipe.descricao}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-danger ms-4" onClick={closeModal}>
                  Cancelar
                </button>
                <button className="btn btn-success ms-4" onClick={Salvar}>
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="row">
        <h1 className="ms-4">Lançamento das Viagens</h1>

        <p className="ms-4">Rotina para lançar as viagens das rotas.</p>
        <hr />
      </div>

      <div className="row ps-2 pe-2">
        <div className="col-sm-6">
          <label className="form-label form-check-label" htmlFor="busca">
            Busque aqui
          </label>
          <input
            type="text"
            placeholder="Buscar por: Código ou Local"
            name="busca"
            id="busca"
            className="form-control me-3"
            value={abusca}
            onChange={(e) => setabusca(e.target.value)}
          />
        </div>

        <div className="col-sm-2">
          <label htmlFor="periodo" className="form-label">
            Lançamento de...
          </label>
          <br />
          <input
            type="date"
            id="periodo"
            className="form-control"
            placeholder="Data Inicio"
            value={dt1}
            onChange={(e) => setdt1(e.target.value)}
          />
        </div>

        <div className="col-sm-2">
          <label htmlFor="periodo" className="form-label">
            Para...
          </label>
          <br />
          <input
            type="date"
            id="periodo2"
            className="form-control"
            placeholder="dtnascimento"
            value={dt2}
            onChange={(e) => setdt2(e.target.value)}
          />
        </div>

        <div className="col-sm-2 d-flex justify-content-center">
          <button className="btn btn-success btnnovo" onClick={(e) => Novo()}>
            Novo
          </button>
        </div>
      </div>

      <div className="row mt-3">
        <hr />
      </div>

      <table className="table table-hover fonte">
        <thead>
          <tr>
            <th className="codigo">Código</th>
            <th className="lancamento">Lançamento</th>
            <th className="dtinicio">Dt. Início</th>
            <th className="dtfim">Dt. Fim</th>
            <th className="local">Local</th>
            <th className="acoes">Ações</th>
          </tr>
        </thead>
        <tbody>
          {listaviagem.map(function (item) {
            return (
              <tr key={item.codviagem}>
                <th>{item.codviagem}</th>
                <th>{FormataDataHora(item.dtlancamento)}</th>
                <th>{FormataData(item.dtinicio)}</th>
                <th>{FormataData(item.dtfim)}</th>
                <th>{item.local}</th>
                <th>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn fa-regular fa-pen-to-square"
                      onClick={() => Editar(item)}
                    ></button>
                    <button
                      className="btn fa-regular fa-square-check"
                      onClick={() => Finalizar(item)}
                    ></button>
                    <button
                      className="btn fa-solid fa-trash"
                      onClick={() => {
                        setexcluido(true);
                        handleOpen(item);
                      }}
                    ></button>
                  </div>
                </th>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={6}>Quantidade de Registros: {listaviagem.length}</th>
          </tr>
        </tfoot>
      </table>
    </>
  );
}

export default LancViagem;
